export default "__VITE_ASSET__KJOmWzQu__"